import _ from "lodash";
export const findLabel = ({ value, options }) => {
  const { label = "" } = _.find(options, ["value", value]) ?? {};
  return label;
};
